import React, { useEffect, useContext } from "react";
import "../Components/Orders/Orders.css";
import { techappContext } from "../../Api/techappReq";
import { Skeleton } from "antd";
import Empty from "../Components/empty";
import OrderCard from "../Components/order_card";

const FailedOrders = () => {
  const skeletonItems = [1, 1, 1, 1];

  const { getOrder, orders, loading } = useContext(techappContext);

  useEffect(() => {
    getOrder("reject");
  }, []);

  return (
    <div className="tech-app-orders-container">
      {/* list view */}
      {!loading &&
        orders?.reject?.length > 0 &&
        orders?.reject?.map((order, index) => (
          <OrderCard
            order={order}
            index={index}
            type={order.status_name}
            labelColor={"red"}
          />
        ))}
      {/* empty list */}
      {!loading && orders?.reject?.length === 0 && (
        <Empty title={"سفارشی یافت نشد."} />
      )}
      {/* skeleton loading */}
      {loading &&
        skeletonItems.map((item, index) => (
          <Skeleton.Button
            style={{
              width: "100%",
              height: "130px",
              marginBottom: "10px",
              borderRadius: "8px",
            }}
            shape={"square"}
            active
            key={index}
          />
        ))}
    </div>
  );
};
export default FailedOrders;
